import React, { useState, useEffect } from "react";

import { Container, Row, Col, Card, Media } from "react-bootstrap";

import ReactPlayer from "react-player";

import iconLivedTime from "../assets/img/ic_lived_time.png";
import iconViewer from "../assets/img/ic_viewer.png";

import { getElapsedTime } from "../utils";

const Live = (props) => {
  const { streaming, liveStartedAt, viewCount } = props;

  const [liveSpent, setLiveSpent] = useState("00:00:00");

  /*const history = useHistory();

  const { streamings, streaming, liveStartedAt, viewCount } = props;

  const [liveSpent, setLiveSpent] = useState("00:00:00");*/

  const updateLiveSpent = () => {
    setInterval(() => {
      setLiveSpent(
        getElapsedTime(new Date().getTime(), new Date(liveStartedAt).getTime())
      );
    }, 1000);
  };

  /*const onItemClicked = (streaming) => {
    history.push(`/${streaming.id}`);
    window.location.reload();
  };*/

  useEffect(() => {
    updateLiveSpent();
  });

  return (
    <Container fluid style={{ padding: "0 0 0 0" }}>
      <Row>
        {/* <Col xs={12} sm={12} md={4}>
          {streamings.map((streaming) => (
            <Card
              key={streaming.id}
              className="card-item mb-3"
              onClick={() => onItemClicked(streaming)}
            >
              <Row>
                <Col xs={6} className="center-vertically">
                  <Image
                    src={
                      streaming.thumbnail
                        ? streaming.thumbnail
                        : defaultThumbnail
                    }
                    fluid
                  />
                </Col>
                <Col xs={6} className="pl-0">
                  <h6 className="title pt-2 mt-3 mb-0 line-clamp">
                    {streaming.title}
                  </h6>
                  <Media className="align-items-center pt-3">
                    <span className="avatar avatar-sm rounded-circle">
                      <img src={streaming.streamer.streamerProfile} alt="" />
                    </span>
                    <Media.Body>
                      <h6 className="mb-0 ml-2 text-muted small-text">
                        {streaming.streamer.name}
                      </h6>
                    </Media.Body>
                  </Media>
                  <h6 className="text-muted mt-3 mb-2 small-text">
                    {formatViewers(streaming.displayViews)} views{" "}
                    <span className="ml-2">
                      {moment(streaming.liveStartedAt)
                        .startOf("minute")
                        .fromNow()}
                    </span>
                  </h6>
                </Col>
              </Row>
            </Card>
          ))}
        </Col> */}
        <Col xs={12} sm={12} md={12}>
          {streaming ? (
            <Card className="pb-4 mb-4">
              <div className="relative-pos">
                <ReactPlayer
                  url={streaming.streamSource}
                  controls
                  width="100%"
                  height="480px"
                  style={{ backgroundColor: "black" }}
                />
                ,
                <div className="top-left mt-3">
                  <span className="text-white small-text">
                    <img
                      width="20"
                      height="20"
                      className="mb-1 mr-1"
                      src={iconLivedTime}
                      alt=""
                    />
                    {liveSpent}
                  </span>
                </div>
                <div className="top-right m-3">
                  <span className="text-white small-text">
                    <img
                      src={iconViewer}
                      width="20"
                      height="20"
                      className="mr-2 mb-1"
                      alt=""
                    />
                    {viewCount}
                  </span>
                </div>
              </div>
              <Row className="pl-5 pr-5 pt-5">
                <Col xs={12}>
                  <h6>{streaming.title}</h6>
                  <h6 className="text-muted small-text">
                    {streaming.description}
                  </h6>
                  <Media className="align-items-center pt-3">
                    <span className="avatar rounded-circle">
                      <img src={streaming.streamer.streamerProfile} alt="" />
                    </span>

                    <Media.Body>
                      <h6 className="mb-0 ml-3">{streaming.streamer.name}</h6>
                    </Media.Body>
                  </Media>
                </Col>
              </Row>
            </Card>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};

export default Live;
